import * as actions from '@app/actions/index';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import CarriersComponent from './carriers.component';

function mapStateToProps(authState: any): any {
	return {
		intl: null,
	};
}

function mapDispatchToProps(dispatch: Dispatch<actions.AuthActions>): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(CarriersComponent);



// WEBPACK FOOTER //
// ./src/components/admin/carriers/carriers.ts